import axios from "axios";
import { Toast as showToast } from "core/components/global/toast/toast";
import { fetchBaseProxyUrl } from "core/utils/common";


const baseURL = fetchBaseProxyUrl({});

export const fetchTokenService = async () => {
  const response: any = await axios.request({
    method: 'GET',
    url: `${baseURL}/auth/token`,
    withCredentials: true
  });
  // const data = response.data;
  return(response)
}

export const checkTokenService = async (token) => {
  let response;
  
  try {
    response = await axios.request({
      method: "POST",
      url: `${baseURL}/auth/verify_token`,
      withCredentials: true,
      data: {
        "token": token
      },
    });
  } catch (error) {
    response = error.response;
  }

  return(response)
}

/**
 * Redirects users to the login IDP
 */
export const loginService = async () => {
  window.location.href = `${baseURL}/saml/login`;
  return null;
}

/**
 * Logsout users from the login IDP and redirects them back
 */
export const logoutService = async () => {
  try {
    // Make an API call to clear server-side session data
    await axios.request({
      method: "GET",
      url: `${baseURL}/saml/logout`,
      withCredentials: true
    });
  } catch (error) {
    console.log("Logout error:", error);
  } finally {
    // Redirect to login page regardless of API result
    window.location.href = "/console/login";
  }
  return null;
}
  

/**
 * Gets the IDP user data for a logged in user 
 * @returns 
 */
export const userService = async () => {
  // Fetch user data with the JWT cookie
  const response = await axios.request({
    method: "GET",
    url: `${baseURL}/saml/user`,
    withCredentials: true
  })

  return(response.data);
}


